import get from 'lodash/get';

export const responseDataToArticle = data => {
  return {
    id: get(data, 'id'),
    htmlBody: get(data, 'attributes.htmlBody'),
    title: get(data, 'attributes.title'),
  };
};

export const responseToArticleList = response => {
  const responseData = get(response, 'data.data');

  if (!responseData) return [];

  return responseData.map(responseDataToArticle);
};
